var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "icon-facebook_svg__a",
  d: "M17 16.3c0 .424-.214.7-.646.7h-3.632v-5.297h1.847l.28-2.27h-2.127V8.251c0-.606.167-1.09 1.062-1.09h1.272V5.357c-.39-.026-.992-.083-1.782-.083-1.64 0-2.885.976-2.885 2.77v1.388H8.444v2.27h1.945V17H3.653C3.218 17 3 16.724 3 16.3V3.942C3 3.518 3.218 3 3.653 3h12.701c.432 0 .646.518.646.942V16.3z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  fillRule: "evenodd",
  xlinkHref: "#icon-facebook_svg__a"
})));
export default SvgIconFacebook;